export default __webpack_public_path__ + "static/media/ig5.330c43a9.svg";